/*
Alla prima pubblicazione per ENAC o ECFOP bisogna verificare l'impostazione delle presenze/assenze nello stage per i corsisti (aggiunta la mezzora solo per GREEN)
*/
window.ENAC = true   // attenzione !!!!
window.GREEN = false  // attenzione !!!!
window.ECFOP = !window.ENAC && !window.GREEN

if(window.GREEN) window.ENAC = false

window.VERSION = "V.1.2.01"

import { DateTime } from "luxon";

window.MODULIJOIN = window.ENAC

let getUserLIV = false
let getUserID = false

// parametri sicuri: funzionano solo in DEBUG
// getUserID = 3270 // AUGELLO
// window.loctime = DateTime.local(2025,11,19,11,40,32,0)
// getUserLIV = 7

document.title = window.ENAC ? "ENAC" : (window.GREEN ? "Fondazione Green" : "E.C.Fo.P.")
//document.querySelector("link[rel='shortcut icon']").href = window.ENAC ? "img/faviconenac.ico" : "img/favicon.png";
document.querySelector("link[rel*='icon']").href = window.ENAC ? "img/faviconenac.ico" : (window.GREEN ? "img/favicongreen.png" : "img/favicon.png");

console.log(window.VERSION)

window.DEBUG = true && (process.env.NODE_ENV == 'development');

// ATTENZIONE: sono anche in router.js perché viene caricato prima
window.secret = "ropels3cr3t"
window.keyname = "jwt5"

import './registerServiceWorker'

// tabella host per versione swone
var produrl = ''
var tblh = {
  "localhost": (window.ENAC ? "swoneenac2" : "swone2"),
  "swone": "swone2",
  "ecfoptest.homeip.net": "swone2.homeip.net",
  "fadecfop.homeip.net": "swone2.homeip.net",
  "swone.ecfop.it": "swone2.ecfop.it",
  "swoneenac": "swoneenac2",
  "enactest.homeip.net": "enac2.homeip.net",
  "enac.homeip.net": "enac2.homeip.net",
  "swone.cfpcanossa.it": "webapp.cfpcanossa.it",
  "swone.fondazionegreen.it": "webapp.fondazionegreen.it",
}
var url = new URL(window.location.href);
if(url.searchParams.get("app")){
  if(tblh[window.location.hostname])
    produrl = `${window.location.protocol}//${tblh[window.location.hostname]}`
}
window.baseurl = (process.env.NODE_ENV == 'development' ? 'http://swone2' : produrl)
console.log("DBG:",window.location.hostname,produrl,window.baseurl)


import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css"
Vue.component('multiselect', Multiselect)


import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'
Vue.component('datetime', Datetime);

// importo globalmente !
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

import VueLuxon from "vue-luxon";
Vue.use(VueLuxon);

import Lightbox from 'vue-pure-lightbox'
Vue.use(Lightbox)


var loctime = url.searchParams.get("loctime");
if(loctime){
  window.loctime_par = DateTime.fromISO(loctime)
  console.log("DBG: loctime",window.loctime_par)
}

window.MD5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}
// import FullCalendar from 'vue-full-calendar'
// Vue.use(FullCalendar)
//import 'fullcalendar/dist/fullcalendar.css'
//import 'fullcalendar/dist/fullcalendar.print.css'
import { API } from "@/api.js";
import VueJWT from 'vuejs-jwt'
Vue.use(VueJWT, {})
var jwt = require('jsonwebtoken')

axios.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem(window.keyname);
    if (token) {
      config.headers['Authorization'] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// todo
// cssVars()

Vue.use(BootstrapVue)

// li gestisco così, per non iniettarli inutilmente in tutti i controlli
window.myMixin = {
  created: function () {
    this.hello()
  },
  computed: {
    ENAC(){
      return window.ENAC
    },
    ECFOP(){
		return window.ECFOP
	},
	GREEN(){
		return window.GREEN
	},
},
  methods: {
    hello: function () {
      // console.log('hello from mixin!')
    },
    getTokenData(){
      var token = sessionStorage.getItem(window.keyname)
      //console.log("TOKEN:",token)
      var data = false
      try {
        data = this.$jwt.decode(token, window.secret)  
      } catch (error) {
        console.error("getTokenData",error)
        sessionStorage.setItem(window.keyname,null)
        this.$router.push("/");
      }
      // console.log("DATA!!!",data)
      return data
    },
    getCorsID() {
      var data = this.getTokenData()
      console.log("TOK1:", data)
      if (data && data.sub && data.sub.guest)
        return data.sub.guest.corsistaid
      else
        return 0
    },
    getBackdoor() {
      var data = this.getTokenData()
      console.log("TOK1:", data)
      if (data && data.sub && data.sub.guest)
        return data.sub.bd
      else
        return false
    },
    getTest() {
      var data = this.getTokenData()
      console.log("TOK1:", data)
      if (data && data.sub && data.sub.guest)
        return data.sub.test
      else
        return false
    },
    getAlunnoID() {
      var data = this.getTokenData()
      console.log("TOK1:", data)
      if (data && data.sub && data.sub.guest)
        return data.sub.guest.alunnoid
      else
        return 0
    },
    getSchema() {
      var data = this.getTokenData()
      // console.log("TOK2:", data)
      if (data && data.sub)
        return data.sub.schema
      else
        return "public"
    },
    getUserID() {
    if(window.DEBUG && getUserID) return getUserID
      var data = this.getTokenData()
      // console.log("TOK3:", data)
      if (data && data.sub && data.sub.user)
        return data.sub.user.docenteid
      else if (data && data.sub && data.sub.guest)
        return data.sub.guest.corsistaid
      else
        return "USERID"
    },
    getUser() {
      var data = this.getTokenData()
      // console.log("TOK3:", data)
      if (data && data.sub && data.sub.user)
        return data.sub.user
      else if (data && data.sub && data.sub.guest)
        return data.sub.guest
      else
        return "USERID"
    },
    getGenitore() {
        var data = this.getTokenData()
        // console.log("TOK3:", data)
        if (data && data.sub && data.sub.guest && data.sub.guest.customdata) {
            let jcustomdata = JSON.parse(data.sub.guest.customdata)
            return jcustomdata.genPW
        } else {
          return null
        }
      },
    getUserLIV() {

		if(window.DEBUG && getUserLIV!==false) return getUserLIV

  	var data = this.getTokenData()
      // console.log("TOK4:", data)
      if (data && data.sub && data.sub.user)
        return data.sub.user.livello
      else
        return "USERLIV"
    },
    getUserName() {
      var data = this.getTokenData()
      if (data && data.sub && data.sub.user)
        return data.sub.user.nome
      else if (data && data.sub && data.sub.guest)
        return data.sub.guest.nome + " " + data.sub.guest.cognome
      else
        return "USERNAME"
    },
  }
}

/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App, Vue
  }
})

// se ho il token faccio qui la richiesta
let token = sessionStorage.getItem(window.keyname);
if (token){
  try {
    if(jwt.verify(token, window.secret)) {

      API.getpars(vue)

      // axios.get(window.baseurl + "/getpars").then( ps => {
      //   console.log("GETPARS:",ps.data.dati)
      //   ps.data.dati.map( p => {
      //     window[p.nome] = p.valore
      //     console.log(p.nome + " = " + p.valore)
      //   })
      // })
    } else {
      sessionStorage.getItem(window.keyname,null)
      token = null
    }
  } catch(e){
    sessionStorage.getItem(window.keyname,null)
    token = null
  }
}
